import { ReactNode } from 'react';
import { Box, InputLabel as MuiInputLabel, InputLabelProps, Typography } from '@mui/material';
import { Tooltip, DEPRECATED_TOOLTIP_TEXT } from '@components/tooltip/Tooltip';
import { requiredFieldStyle, requiredBeforeBindFieldStyle } from './InputLabel.styles';
import { DeprecatedIcon } from '@components/tooltip/DeprecatedIcon';

const containerStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-end',
  width: '100%',
  svg: {
    marginTop: '0px',
    marginLeft: '5px',
    marginBottom: '-3.5px',
    width: '15px',
    height: '15px',
  },
} as const;

export interface IInputLabel extends InputLabelProps {
  endIcon?: ReactNode;
  tooltipTitle?: ReactNode;
  deprecated?: boolean | null;
  requiredBeforeBind?: boolean;
}

export const InputLabel = (props: IInputLabel) => {
  const { endIcon, tooltipTitle, children, deprecated, requiredBeforeBind, ...other } = props;

  const labelContent = (
    <Box
      sx={[
        containerStyle,
        {
          svg: {
            color: 'text.subdued',
          },
        },
      ]}
    >
      <MuiInputLabel {...other} required={false} {...(requiredBeforeBind ? { 'data-required-before-bind': true } : {})}>
        <Typography
          variant='caption'
          color={other.error ? 'error.main' : other.disabled ? 'text.disabled' : 'text.caption'}
          sx={{
            ...(other.required ? requiredFieldStyle : requiredBeforeBind ? requiredBeforeBindFieldStyle : {}),
            ...(deprecated ? { textDecoration: 'line-through' } : {}),
          }}
        >
          {deprecated && <DeprecatedIcon />}
          {children}
        </Typography>
        {endIcon}
      </MuiInputLabel>
    </Box>
  );

  const inputLabel =
    tooltipTitle || deprecated ? (
      <Tooltip
        config={{ allowWhiteSpace: true, applyMarkup: true }}
        title={
          deprecated
            ? tooltipTitle
              ? `${DEPRECATED_TOOLTIP_TEXT}\n\n${tooltipTitle}`
              : DEPRECATED_TOOLTIP_TEXT
            : tooltipTitle
        }
      >
        {labelContent}
      </Tooltip>
    ) : (
      labelContent
    );
  return inputLabel;
};
